import React from 'react';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const ProgressItem = styled.div `
  position: relative;
  padding: 5px 0 5px 25px;
  font-size: 0.85em;
  font-weight: ${(props) => (props.active ? 'bold' : 'normal')};
  &::before {
    content: ' ';
    left: 9px;
    top: 12px;
    height: 100%;
    width: 3px;
    background-color: lightgrey;
    position: absolute;
  }
  &:last-child::before {
    display: none;
  }
  &::after {
    content: ' ';
    left: 5px;
    top: 9px;
    height: 11px;
    width: 11px;
    border-radius: 100%;
    background-color: ${(props) => props.active || props.past ? THEME.COLOR_ACCENT : 'grey'};
    position: absolute;
  }
`;
const Progress = (props) => {
    let past = true;
    return (React.createElement("div", null, props.items.map((item) => {
        if (item.active) {
            past = false;
        }
        return (React.createElement(ProgressItem, { key: item.title, active: item.active, past: past, onClick: item.onClick, style: {
                cursor: item.onClick ? 'pointer' : undefined,
            } }, item.link ? (React.createElement(Link, { style: {
                textDecoration: 'inherit',
                color: 'inherit',
            }, to: item.link }, item.title)) : (item.title)));
    })));
};
export default Progress;
//# sourceMappingURL=Progress.js.map